import React, { ReactElement } from 'react';
import './styles.scss';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faHeart } from '@fortawesome/free-solid-svg-icons';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Breadcrumb from 'components/Breadcrumb';
import DataPeriodSelect from 'components/DataPeriodSelect';

interface Props {
  title?: string;
  onCreateGroupClick?: any;
  onExportClick: any;
  onFavoritesClick(): any;
  onFilterClick?(): any;
  onWeekScopeSelect: any;
  weeks?: number;
  onSelectedTabChange?: (selectedTab: string) => void;
  children?: ReactElement;
}

const PageHeader: React.FC<Props> = ({
  onCreateGroupClick,
  onExportClick,
  onFavoritesClick,
  onFilterClick,
  onWeekScopeSelect,
  weeks,
  onSelectedTabChange,
  children = null
}) => (
  <div className="page-header">
    <Breadcrumb onSelectedTabChange={onSelectedTabChange} />
    <div className="buttons">
      <DataPeriodSelect currentWeeks={weeks} onSelect={onWeekScopeSelect} />
      <div className="custom-buttons">
        {onFilterClick && (
          <>
            <Button onClick={onFilterClick}>
              <FontAwesomeIcon className="filter-icon" icon={faFilter} />
              <span>Filter</span>
            </Button>
            <span className="separator">|</span>
          </>
        )}
        <OverlayTrigger
          delay={500}
          placement="bottom"
          overlay={<Tooltip id="favorites-tooltip">Save to Favorites</Tooltip>}
          trigger={['hover', 'focus']}
        >
          <Button onClick={onFavoritesClick}>
            <FontAwesomeIcon icon={faHeart} />
          </Button>
        </OverlayTrigger>
        <OverlayTrigger
          delay={500}
          placement="bottom"
          overlay={<Tooltip id="export-tooltip">Export</Tooltip>}
          trigger={['hover', 'focus']}
        >
          <Button onClick={onExportClick}>
            <FontAwesomeIcon icon={faFileExcel} />
          </Button>
        </OverlayTrigger>
        {onCreateGroupClick && (
          <>
            <span className="separator">|</span>
            <Button onClick={onCreateGroupClick}>Create Group</Button>
          </>
        )}
        {children}
      </div>
    </div>
  </div>
);

export default PageHeader;
